import { tiktokQueries } from '@round/api';
import { useQuery } from '@tanstack/react-query';

const options = tiktokQueries.audio.options.list;

type GetTiktokAudiosParams = Parameters<typeof options>[0];
type QueryOptions = Pick<ReturnType<typeof options>, 'enabled' | 'placeholderData'>;

export function useTiktokAudios(params: GetTiktokAudiosParams, queryOptions?: QueryOptions) {
    const query = useQuery({
        ...options(params),
        ...queryOptions,
    });

    return {
        data: query.data,
        isFetching: query.isFetching,
        isLoading: query.isLoading,
        isSuccess: query.isSuccess,
        isError: query.isError,
    };
}
